import { useIsFoldable } from "@navigations/utils/FoldableWrapper";
import { useCallback, useState } from "react";
import {
  Dimensions,
  LayoutChangeEvent,
  useWindowDimensions,
} from "react-native";
import { useTheme } from "styled-components/native";
import { getComponentDimentions } from "../utils/utils";

interface PdpLayoutParams {
  route: any;
}

export const usePdpLayoutState = ({ route }: PdpLayoutParams) => {
  const theme = useTheme();
  const { deviceWidth: windowWidth } = useIsFoldable();
  const windowDimensions = useWindowDimensions();

  const width = route?.params?.containerWidth ?? windowWidth;
  const height = route?.params?.containerHeight ?? windowDimensions.height;

  const screenWidth = width;
  const screenHeight =
    route?.params?.containerHeight ?? Dimensions.get("window").height;

  const [contentWidth, setContentWidth] = useState(width ?? 375);
  const [rightComponentWidth, setRightComponentWidth] = useState(0);

  const { sizes } = getComponentDimentions(theme, height, width);

  const handleLayout = useCallback(
    (e: LayoutChangeEvent) => {
      setContentWidth(theme.isMobile ? width : e.nativeEvent.layout.width);
    },
    [theme.isMobile, width]
  );

  const handleLayoutPDP = (event: any) => {
    const { width: layoutWidth } = event.nativeEvent.layout;
    setRightComponentWidth(layoutWidth);
  };

  return {
    width,
    height,
    screenWidth,
    screenHeight,
    contentWidth,
    rightComponentWidth,
    sizes,
    handleLayout,
    handleLayoutPDP,
  };
};
